import React from 'react';

import T from 'Utilities/texts';
import { PRO_URL } from 'Utilities/urls';

import styles from './More.scss';

/* Add this as soon as the Affiliate page is live, change # to real href
  <a href="#" target="_blank" className={styles.box}>
    <h5 className="mw-title-title6">
      {T.translate('aboutPage.more.box2.title')}
    </h5>
    <p className={cx(styles.text, 'mw-title-small')}>
      {T.translate('aboutPage.more.box2.text')}
    </p>
</a> */

const More = React.memo(() => (
  <div className={styles.moreBox}>
    <h3 className="mw-title-title3">
      {T.translate('aboutPage.more.title')}
    </h3>
    <div className={styles.inner}>
      <div className={styles.box}>
        <h5 className="mw-title-title6">
          {T.translate('aboutPage.more.box1.title')}
        </h5>
        <p className={styles.text}>
          {T.translate('aboutPage.more.box1.text')}
        </p>
        <div className={styles.link}>
          <a
            className="mw-link mw-link-blue"
            href={PRO_URL}
            rel="noreferrer"
            target="_blank"
          >
            {T.translate('aboutPage.more.find')}
          </a>
        </div>
      </div>
      <div className={styles.box}>
        <h5 className="mw-title-title6">
          {T.translate('aboutPage.more.box3.title')}
        </h5>
        <p className={styles.text}>
          {T.translate('aboutPage.more.box3.text')}
        </p>
        <div className={styles.link}>
          <a className="mw-link mw-link-blue" href="/press" target="_blank">
            {T.translate('aboutPage.more.find')}
          </a>
        </div>
      </div>
    </div>
  </div>
), () => true);

export default More;
